export const CONNECTION_STATES = {
  ONLINE: 'online',
  SLOW: 'slow',
  UNSTABLE: 'unstable',
  OFFLINE: 'offline',
};

export const LATENCY_THRESHOLD_SLOW = 2000;
export const PING_INTERVAL_NORMAL = 30000;
export const PING_INTERVAL_DEGRADED = 10000;
export const DEBOUNCE_WINDOW = 5000;
export const CONSECUTIVE_FAILURES_UNSTABLE = 3;
export const SLOW_EFFECTIVE_TYPES = ['slow-2g', '2g'];
export const PING_TIMEOUT = 5000;
export const TOAST_THROTTLE = 15000;
